<template>
  <div class="intrdCard">
    <div class="grid-container">
      <div v-for="(item, index) in list" :key="index"  class="grid-item">
        <ul @click="link(item.url)">
          <li class="title">{{item.title}}</li>
          <li class="desc" v-if="isMobile">{{item.desc}}</li>
          <li class="link" v-else>
            <span>바로가기</span>
          </li>
          <li class="icon">
            <img :src="imageSrc(item.img)" alt="item.img">
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name : 'IntrdCard',
  data() {
    return {
      isMobile: false,
      list: []
    }
  },
  mounted () {
    window.addEventListener('resize', this.onResize);
    this.$nextTick(() => {
      this.onResize()
    })
    this.init();
  },
  methods: {
    init() {
      this.list = [
        {
          title : '클럽소개',
          desc: '전남드래곤즈 방문을 환영합니다.',
          img: 'icon_logo.png',
          url: '/club/history',
        },
        {
          title : '티켓예매',
          desc: '티켓예매를 진행하실 수 있습니다.',
          img: 'icon_ticket.png',
          url: '/ticket/reservations',
        },
        {
          title : '경기장',
          desc: '전남드래곤즈의 경기장을 소개합니다.',
          img: 'icon_main_ball.png',
          url: '/club/stadium',
        },{
          title : '사회공헌활동',
          desc: '전남드래곤즈의 사회공헌활동을 소개합니다.',
          img: 'icon_csr.png',
          url: '/club/csr',
        }
      ]
    },
    link(url) {
      if(url) {
        this.$router.push(url)
      } else {
        alert('준비중입니다.')
      }
    },
    onResize () {
      this.isMobile = window.innerWidth < 960
    },
    imageSrc(imgSrc) {
      return require('@/assets/img/icon/'+imgSrc);
    }
  }
}
</script>
